import {home} from "./pages/home";

home();
